import axios from '../../localAxios';
import { workspaceFoldersURL } from '../workspacesURLs';
import { WorkspaceFolder } from './types';

interface GetWorkspaceFoldersParams {
  workspaceId: string;
  isDeleted?: boolean;
}

export async function getWorkspaceFolders({
  workspaceId,
  isDeleted,
}: GetWorkspaceFoldersParams) {
  const url = workspaceFoldersURL({
    workspaceId: workspaceId,
    isDeleted: isDeleted,
  });
  const response = await axios.get<WorkspaceFolder[]>(url.href);
  return response.data;
}
